import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
  name: "formatPrice"
})

export class FormatPricePipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    if(value){
      value.toLocaleString('en-US', {style: 'currency'})
    } else {
      return '';
    }
  }
}
